import { Button, ButtonGroup } from "@nextui-org/react";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

function FilterButtons({ filters, haveAll = true }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedFilter, setSelectedFilter] = useState(null);

    useEffect(() => {
        // Initialize selectedFilter based on URL parameters when the component mounts
        const currentFilterType = filters.find(
            (filter) =>
                searchParams.get(`filter[${filter.field}]`) === filter.value
        )?.type;
        setSelectedFilter(currentFilterType || null);
    }, [searchParams, filters]);

    const handleFilterButton = (filterType) => {
        setSelectedFilter(filterType);

        const newSearchParams = new URLSearchParams(searchParams);
        const filter = filters.find((f) => f.type === filterType);
        if (filter) {
            newSearchParams.set(`filter[${filter.field}]`, filter.value);
        }

        // If needed, reset the page to 1 when changing filters
        if (newSearchParams.get("page") > 1) {
            newSearchParams.set("page", 1);
        }

        setSearchParams(newSearchParams);
    };

    const handleClearFilter = () => {
        const newSearchParams = new URLSearchParams(searchParams);
        // Remove all filter parameters except the page
        filters.forEach((filter) => {
            newSearchParams.delete(`filter[${filter.field}]`);
        });
        setSelectedFilter(null); // Clear the selected filter state

        setSearchParams(newSearchParams);
    };

    // Determine if the "كل" button should be active
    const isClearButtonActive = () => {
        const hasFilterParams = filters.some((filter) =>
            searchParams.has(`filter[${filter.field}]`)
        );
        return !hasFilterParams;
    };

    return (
        <div className="flex items-center justify-center">
            <ButtonGroup size="md">
                {haveAll && (
                    <Button
                        onClick={handleClearFilter}
                        className={`${
                            isClearButtonActive() &&
                            "bg-secondary-color text-white"
                        }`}
                    >
                        الكل
                    </Button>
                )}
                {filters.map((filter) => (
                    <Button
                        key={filter.type}
                        onClick={() => handleFilterButton(filter.type)}
                        className={`${
                            selectedFilter === filter.type &&
                            "bg-secondary-color text-white"
                        }`}
                    >
                        {filter.label}
                    </Button>
                ))}
            </ButtonGroup>
        </div>
    );
}

export default FilterButtons;
